import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import globals from '../../../globals/communityGlobals';
import { parseDateUtc } from '../../../utils/dates';
import YearMonthForm from './YearMonthForm';

class CommunityDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: this.props.selectedDate ? parseDateUtc(this.props.selectedDate) : parseDateUtc(new Date()),
      monthSelected: this.props.selectedDate
        ? parseDateUtc(this.props.selectedDate).month()
        : parseDateUtc(new Date()).month(),
      yearSelected: this.props.selectedDate
        ? parseDateUtc(this.props.selectedDate).year()
        : parseDateUtc(new Date()).year(),
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef = node => {
    this.wrapperRef = node;
  };
  handleTodayClick = () => {
    this.setState({
      selectedDay: parseDateUtc(new Date()),
      monthSelected: parseDateUtc(new Date()).month(),
      yearSelected: parseDateUtc(new Date()).year(),
    });
    const newSelectedDate = parseDateUtc(new Date()).format(globals.dateFormats.date);
    this.props.changeDate(newSelectedDate, this.props.currentPath);
    this.props.close();
  };

  handleMonthChange = e => {
    const month = e.target.value;
    this.setState({
      monthSelected: Number(month),
    });
  };

  handleYearChange = e => {
    const year = e.target.value;
    this.setState({
      yearSelected: Number(year),
    });
  };

  toggleMonths = e => {
    this.setState({
      monthSelected: e.getMonth(),
      yearSelected: e.getFullYear(),
    });
  };

  handleDayClick = day => {
    this.setState({
      selectedDay: parseDateUtc(day),
    });
    const newSelectedDate = parseDateUtc(day).format(globals.dateFormats.date);
    this.props.changeDate(newSelectedDate, this.props.currentPath);
    this.props.close();
  };

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.close();
    }
  };

  render() {
    const { selectedDay, yearSelected, monthSelected } = this.state;
    return (
      <div className="calendar-container" ref={this.setWrapperRef} id="main-header-calendar">
        <YearMonthForm
          onToday={this.handleTodayClick}
          handleMonthChange={this.handleMonthChange}
          handleYearChange={this.handleYearChange}
          monthSelected={monthSelected}
          yearSelected={yearSelected}
        />
        <DayPicker
          showWeekNumbers
          firstDayOfWeek={1}
          month={new Date(yearSelected, monthSelected)}
          selectedDays={selectedDay.toDate()}
          onDayClick={this.handleDayClick}
          onMonthChange={this.toggleMonths}
        />
      </div>
    );
  }
}

CommunityDatePicker.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
  currentPath: PropTypes.string.isRequired,
};

export default CommunityDatePicker;
